import PjaxWrapper from '../utils/PjaxWrapper';
import Flux from '../flux/Flux';

const ROUTEMESSENGER = 'Messenger';

/**
 * runner
 *
 * @param routeName
 */
function run(routeName) {
	if (routeName !== ROUTEMESSENGER) {
		const _onReady = function () {
			const bodyContainer = document.getElementsByClassName('js-main-body')[0];
			if (bodyContainer) {
				const clb = function (e) {
					if (Flux.Messenger.getSelectedChannel()) {
						e.preventDefault();
						e.stopPropagation();
						Flux.Messenger.unselectChannel();
						Flux.Messenger.clearChannel();
					}
				};
				bodyContainer.addEventListener('click', clb, true);
				PjaxWrapper.addUnloadFunc(() => {
					bodyContainer.removeEventListener('click', clb, true);
				});
			}
		};

		if (document.readyState !== 'loading') {
			_onReady();
		} else {
			window.addEventListener('DOMContentLoaded', _onReady, false);
		}
	}
}

export { run };
